<template>
  <div
    :class="{ 'has-danger': error }"
    class="form-group row">
    <label
      :for="labelId"
      class="col-4 col-form-label">{{labelText}}
      <span
        class="text-danger"
        v-if="allowEmpty">*</span>
    </label>
    <div class="col-8">
      <vue-multiselect
        :options="options"
        :multiple="multiple"
        :searchable="searchable"
        :allow-empty="allowEmpty"
        :value="getSelectedMultiselectByValue(value, options, 'value')"
        placeholder="Выбрать"
        selectedLabel="Выбрано"
        deselectLabel="Нажимите для удаления"
        selectLabel="Нажимите для выбора"
        tag-placeholder="Нажмите Enter для добавления"
        :track-by="trackBy"
        :label="label"
        :taggable="taggable"
        autocomplete="off"
        @tag="addTag"
        @remove="remove"
        @input="changeValue"/>
      <span
        v-if="error"
        class="small help-block text-danger">{{errorText}}</span>
    </div>
  </div>
</template>

<script>
  import VueMultiselect from 'vue-multiselect/src/Multiselect'
  import indexOfProperty from 'helpers/indexOfProperty'
  export default {
    name: 'AdminFormMultiSelect',
    components: {VueMultiselect},
    props: {
      value: {
        default: null
      },
      options: {
        type: Array,
        default () {
          return []
        }
      },
      error: {
        type: Boolean,
        default: false
      },
      allowEmpty: {
        type: Boolean,
        default: true
      },
      errorText: {
        type: String,
        default: 'Неправильно заполнено поле'
      },
      searchable: {
        type: Boolean,
        default: true
      },
      multiple: {
        type: Boolean,
        default: false
      },
      labelText: {
        type: String,
        default: ''
      },
      labelId: {
        type: String,
        default: 'label' + Math.random()
      },
      trackBy: {
        type: String || null,
        default: 'value'
      },
      label: {
        type: String,
        default: 'name'
      },
      taggable: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      changeValue (object) {
        if (!this.taggable && !this.multiple) {
          this.$emit('input', object ? object[this.trackBy] : null)
        } else if (this.multiple) {
          this.$emit('input', object)
        }
      },
      getSelectedMultiselectByValue (value, options, property) {
        if (this.taggable || this.multiple) {
          return value
        }
        let index = indexOfProperty(options, property, value)
        if (index > -1) {
          return options[index]
        }
        return null
      },
      addTag (tag) {
        let tags = Object.assign([], this.value)
        tags.push(tag)
        this.$emit('input', tags)
      },
      remove (object) {
        if (this.taggable) {
          let tags = Object.assign([], this.value)
          let index = tags.indexOf(object)
          if (index !== -1) {
            tags.splice(index, 1)
            this.$emit('input', tags)
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AdminFormMultiSelect.vue?5ae02cf8